var path = 'areas/projects/actions/azure_cloud_service/Octopus.AzureCloudService_summary.html';
var html = "<p> Deploy Azure Cloud Service <strong>{{ properties[\"Octopus.Action.Package.PackageId\"] }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ properties[\"Octopus.Action.Package.FeedId\"] }}</em> <span ng-show='properties[\"Octopus.Action.TargetRoles\"] && isSingleStep'>on behalf of targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_cloud_service/Octopus.AzureCloudService_summary.html
// module id = 6972697352083484
// module chunks = 1